module.exports = __webpack_public_path__ + "img/AFMS_SAMPLING.6aca82c9.png";